import React from "react";
import moment from "moment";
import { Spring } from "react-spring";
import Loading from "../../components/Loading/Loading";
import HeaderComponent from "../../components/Header";
import { notesAction, sessionActions } from "../../store/actions";
import { connect } from "react-redux";
import Footer from "../../components/Footer/footer";
import { history } from "../../helpers";
import "../../static/css/styles.css";
import Swal from "sweetalert2";
import { noteInsideView } from "../../helpers/ConstantID";
import { constants } from "../../Constants";

class NoteView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      note: [],
      noteValue: "",
      disabled: true,
      isEdit: false,
    };
  }

  componentDidMount() {
    const note_id = this.props.match.params.noteid;
    this.props.viewNote(note_id);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      note: [nextProps.note.noteView],
    });
  }

  goback = () => {
    history.push("/note");
  };

  handleEdit = () => {
    this.setState({
      disabled: false,
    });
    document.getElementById("editButton").style.display = "none";
    document.getElementById("saveButton").style.display = "block";
  };

  handelSubmit = () => {
    if (!this.state.isEdit) {
      this.setState({
        isEdit: !this.state.isEdit,
        disabled: false,
      });
    } else {
      const { dispatch } = this.props;
      const note = document.getElementById(noteInsideView.sh_niv_note_text).value;
      const user_id = this.state.note[0].user;
      const appoitment_id = this.state.note[0].appointment;

      dispatch(sessionActions.CreateNote(note, user_id, appoitment_id)).then((res) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          animation: false,
        });
        Toast.fire({
          type: "success",
          title: "Note successfully saved",
        });
      });

      this.setState({
        disabled: true,
        isEdit: !this.state.isEdit,
      });
    }
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      noteValue: value,
    });
  };

  render() {
    if (this.props.note.loading === false) {
      return (
        <div className="sh-layout hoffen-block">
          <HeaderComponent />
          <div className="sh-note-detail-comp sh-gnrl-width">

            {/* Welcome Note */}
						<div className="sh-gnrl-welcome-note">
      <h2 className="sh-gnrl-welcome" >{constants.NOTES_TEXT.toUpperCase()}</h2>
						</div>


            <div className="sh-gnrl-container">
              {this.props.note.noteView &&
                this.state.note.map((v, i) => {
                return (


                <div className="sh-gnrl-cont-content" key={i}>
                  {/* Header for Note detail view */}

                  <div className="sh-gnrl-note-detail-header">
                    <div className="sh-gnrl-ndh-left">
                      
                      <h4 className="sh-gnrl-ndh-dr-name">{JSON.parse(localStorage.getItem("user")).role == "0" ? v.patient: v.counsellor}</h4>
                      <p className="sh-gnrl-ndh-time">
                        {moment(v.date_created).format("ddd DD MMM YYYY hh:mm:ss A").toLocaleString("en-US", {
                          hour: "numeric",
                          hour12: true,
                        })}
                      </p>
                    </div>

                    <div className="sh-gnrl-ndh-right">
                      <div className="sh-gnrl-btn-container">
                        <button id={`${this.state.isEdit ? noteInsideView.sh_niv_save_btn : noteInsideView.sh_niv_edit_btn }`} className={`${this.state.isEdit ? "sh-btn-save" : "sh-btn-edit" }  sh-gnrl-btn-session`} onClick={()=>this.handelSubmit()} >
                          <span className="sh-text-icon">{this.state.isEdit ? "Save" : "Edit"}</span>
                          
                          <span className="icon"></span>
                        </button>
                        <button id={noteInsideView.sh_niv_back_btn} className={`${this.state.isEdit ? "sh-btn-cncl" : "sh-btn-back"} sh-gnrl-btn-session`} onClick={()=>{this.state.isEdit ? this.setState({isEdit:!this.state.isEdit }) : this.goback() }}>
                          <span className="sh-text-icon">{this.state.isEdit ? "Cancel": "Back" }</span>
                          <span className="icon"></span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="sh-gnrl-note-detail-content">
                    <div className="sh-gnrl-ndc-textarea">
                      <textarea  name="noteValue"
                      className={`${this.state.isEdit && "sh-gnrl-border"}`}
                      onChange={this.handleChange}
                      id={noteInsideView.sh_niv_note_text}
                      disabled={this.state.disabled}>
                       {v.body} 
                      </textarea>
                    </div>
                  </div>
                </div>
                )}
              )}
            </div>
          </div>
          <Footer/>
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}

function mapStateToProps(state) {
  const { session, auth, alert, note } = state;
  const { appointments } = state.appointments;
  const { user } = auth;
  return {
    user,
    alert,
    appointments,
    session,
    note,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    viewNote: (user_id) => {
      dispatch(notesAction.viewNote(user_id));
    },
    showNote: (data) => {
      dispatch(notesAction.showNote(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoteView);



// WEBPACK FOOTER //
// ./src/screens/NoteView/index.js